import { createFileRoute } from "@tanstack/react-router";

import { CihHero } from "~/components/cih/hero";
import { CihSection } from "~/components/cih/section";
import { createBrandMeta } from "~/lib/shared/meta";

const URL = "https://dreamcoachmatch.com/about/advisory-council";

const REVIEWER_BYLINE =
  "Reviewed by Yuri Minski, MBA · Founder, Dream Coach Match · 6x Certified Coach · 20+ years marketing";

export const Route = createFileRoute("/_public/about/advisory-council")({
  staticData: { title: "Advisory Council" },
  head: () =>
    createBrandMeta({
      title: "Advisory Council | Dream Coach Match",
      description:
        "The practitioners and operators who review Dream Coach Match's coaching-business guidance for accuracy and real-world rigor.",
      ogUrl: URL,
      canonical: URL,
    }),
  component: AdvisoryCouncilPage,
});

function AdvisoryCouncilPage() {
  return (
    <>
      <CihHero
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "About", href: "/about" },
          { label: "Advisory Council", href: "/about/advisory-council" },
        ]}
        kicker="About"
        kickerColorClass="text-green-700"
        title="Advisory Council"
        lede="The practitioners and operators who keep our coaching-business guidance honest, accurate, and grounded in what actually works."
      />

      <CihSection id="overview" divider={false}>
        <div className="mx-auto max-w-3xl px-4 xl:px-0">
          <div className="prose prose-lg max-w-none prose-a:text-green-700">
            <p>
              Dream Coach Match's coaching-business content is written for
              coaches building their practice — client acquisition, pricing,
              systems, and scale. Because that guidance shapes real decisions
              about real businesses, every guide and playbook is reviewed before
              it publishes.
            </p>
            <p>
              Our advisory review combines marketing rigor, certified coaching
              experience, and hands-on practice-building. Reviewers check claims
              for accuracy, flag anything that overstates a result, and confirm
              that the tactics hold up outside a slide deck. Frameworks
              attributed to outside thought leaders are presented in the third
              person as reference material — their inclusion is analysis, not an
              endorsement of Dream Coach Match by those individuals.
            </p>
          </div>

          <p className="mt-10 border-t border-gray-200 pt-6 text-sm text-gray-600">
            {REVIEWER_BYLINE}
          </p>
        </div>
      </CihSection>
    </>
  );
}
